import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid } from "@signals/commonFilters/filters"


export default function CommonFiltersFooterActions() {
	return <ButtonLoadingSeeker
		loading={isLoadingCommonFilters.value}
		sx={{ px: 4 }}
		onClick={() => isLoadingCommonFilters.value = true}
		disabled={!areCommonFiltersValid.value}
	>
		Search
	</ButtonLoadingSeeker>
}